import { cloneDeep } from 'lodash'
const queue = []
let loading = false
const collapseClass = {
  bg: 'table2-cell-collapse-bg',
  colMark: 'table2-cell-collapse_colMark'
}

let checkExpandTimer

// 执行队列中的方法
async function executeQueue() {
  // 如果已经有方法在执行或队列为空，则直接返回
  if (loading || queue.length === 0) return

  // 获取队列中的第一个方法并执行
  const { fn, context, args } = queue.shift()
  try {
    await fn.apply(context, args)
  } catch (error) {
    console.error('Error while executing changeCollapseKeys:', error)
  } finally {
    loading = false
    // 继续执行队列中的下一个方法
    executeQueue()
  }
}


// 添加方法到队列的函数
function addToQueue(fn, context, args) {
  queue.push({ fn, context, args })
}

function createTransitionTime(v = 3) {
  return `transition: width .${v}s;`
}

const collapseType = {
  expand: 'expand',
  collapse: 'collapse'
}

function formatGroupInfo(group, column) {
  group.push(column)
}

function getCollapseAnimationGroup(collapseKeys, columns) {
  collapseKeys = cloneDeep(collapseKeys)
  const groups = []
  let consecutiveGroup = []
  columns.forEach(column => {
    if (collapseKeys.includes(column.key)) {
      const isChild = column.children && column.children.length
      if (isChild) {
        column.children.forEach(childCol => {
          if (!collapseKeys.includes(childCol.key)) {
            collapseKeys.push(childCol.key)
          }
        })
      }
      formatGroupInfo(consecutiveGroup, column)
    } else {
      if (consecutiveGroup.length > 0) {
        groups.push(consecutiveGroup)
        consecutiveGroup = []
      }
    }
  })
  consecutiveGroup.length > 0 && groups.push(consecutiveGroup)
  // 组装配置参数
  return groups.reduce((res, cur = []) => {
    res.push({
      columnGroups: cur,
      ...cur.reduce((r, c) => {
        const { totalWidth } = r
        r.totalWidth = totalWidth + c.width
        return r
      }, {
        totalWidth: 0
      })
    })
    return res
  }, [])
}

function renderHighlightGroup(collapseAnimationGroup, tableEl, type, callback, vm, emitParams) {
  try {
    collapseAnimationGroup.forEach(groupInfo => {
      groupInfo.columnGroups.forEach(column => {
        const { key } = column
        // 设置列背景色高亮
        column.labelClassName = getCollapseClassNames(column.labelClassName, 'add')
        column.className = getCollapseClassNames(column.className, 'add')
        const colgroup = tableEl.querySelectorAll(`[name="${key}"]`)
        setCellCollapseHighlightClass([], colgroup, type, column)
      })
    })
    const isCollapse = type === collapseType.collapse
    setTimeout(() => {
      removeCellCollapseHighlightClass(tableEl, isCollapse)
      isCollapse && callback()
      vm.table.$emit('collapsed', emitParams)
      vm.table._updateTableHeight() // 存在全部一级头点击展开变成二级头，高度计算有误
    }, isCollapse ? 300 : 500)
  } catch (e) {
    loading = false
  }
}

function setCellCollapseHighlightClass(tds = [], colgroup = [], type, column) {
  tds.forEach(td => {
    const [cellEl] = td.children || []
    if (cellEl && cellEl.classList) {
      cellEl.classList.add(collapseClass.bg)
    }
  })
  colgroup.forEach(col => {
    if (col && col.classList) {
      col.classList.add(collapseClass.colMark)
      col.style = createTransitionTime()
    }
  })
  // 不做重复采集，场景问题： 当折叠收起子级后，马上再点击，收起父级。则会被重复采集，设置为0.1。
  if (type === collapseType.collapse && column.width !== 0.1) {
    column.$collapseWidth = column.width
    column.width = 0.1
  } else {
    column.width = column.$collapseWidth
  }
}

export function removeCellCollapseHighlightClass(tableEl, isRemoveBg) {
  loading = false
  const colgroup = tableEl.querySelectorAll(`.${collapseClass.colMark}`)
  // if (isRemoveBg) {
  //   const cells = tableEl.querySelectorAll(`.${collapseClass.bg}`)
  //   cells.forEach(el => {
  //     el.classList.remove(collapseClass.bg)
  //   })
  // }
  colgroup.forEach(el => {
    el.classList.remove(collapseClass.colMark)
    el.style = ''
  })
}

function resetColumnsWidth(collapseAnimationGroup = []) {
  collapseAnimationGroup.forEach(groupInfo => {
    groupInfo.columnGroups.forEach(column => {
      // 解决默认是折叠，然后点击展开
      if (column.$collapseWidth === undefined) {
        column.$collapseWidth = column.width
      }
      column.width = 0.1
    })
  })
}

function getCollapseClassNames(labelClassName = '', type) {
  try {
    let classNames = labelClassName
    if (type === 'add') {
      if (!labelClassName || !labelClassName.includes(collapseClass.bg)) {
        classNames = `${labelClassName || ''} ${collapseClass.bg}`
      }
    } else {
      classNames = (labelClassName || '').replace(collapseClass.bg, '')
    }
    return classNames
  } catch (e) {
    return labelClassName
  }
}

function setColumnHighlight(column, visibleFlatColumns) {
  const collapseColumn = visibleFlatColumns && visibleFlatColumns.find(col => col.key === column.key)
  if (collapseColumn) collapseColumn.labelClassName = getCollapseClassNames(column.labelClassName, 'add')
}

function removeColumnHighlight(column, visibleFlatColumns) {
  if (column.labelClassName) {
    const collapseColumn = visibleFlatColumns && visibleFlatColumns.find(col => col.key === column.key)
    if (collapseColumn) collapseColumn.labelClassName = getCollapseClassNames(column.labelClassName)
  }
}


function checkExpandColumnPosition(collapseGroup = [], opt = {}) {
  try {
    collapseGroup = collapseGroup.reduce((c, cur) => {
      const columnsGroup = cur.columnGroups || []
      c.push(...columnsGroup.filter(v => v.show !== false))
      return c
    }, [])

    const lastColumn = collapseGroup.pop()
    if (lastColumn) {
      const { tableWidth, scrollPos = {}, leftTableWidth = 0, setTableScrollLeft = () => {} } = opt
      const tableCoveWidth = tableWidth + (scrollPos.scrollLeft || 0)
      const columnOffsetX = lastColumn.offsetX + lastColumn.width
      const r = columnOffsetX > tableCoveWidth
      const l = (columnOffsetX + tableWidth) < tableCoveWidth
      let scrollVal = null
      // 右隐藏
      if (r) {
        scrollVal = (columnOffsetX - tableCoveWidth) + leftTableWidth + scrollPos.scrollLeft
      }
      // 边隐藏
      if (l) {
        scrollVal = lastColumn.offsetX - leftTableWidth
      }

      if (scrollVal !== null && scrollVal >= 0) {
        setTableScrollLeft(scrollVal)
      }
    }
  } catch (e) {
    console.error(e)
  }
}

const collapseMethods = {
  changeCollapseKeysByQueue (key) {
    const keys = Array.isArray(key) ? key : [key]
    const { mainColumns } = this.states
    keys.forEach(key => {
      const column = mainColumns.find(col => col.key === key)
      if (column) {
        addToQueue(this.changeCollapseKeys, this, [column])
      }
    })
    executeQueue()
  },
  changeCollapseKeys(column, isUserClick = false) {
    if (loading) return
    const { collapsed, key, collapseKeys } = column
    if (!Array.isArray(collapseKeys)) { return }
    loading = true
    const val = !collapsed
    const { visibleFlatColumns, scrollPos } = this.states
    const type = collapsed === true ? collapseType.expand : collapseType.collapse
    const collapseAnimationGroup = getCollapseAnimationGroup(collapseKeys, visibleFlatColumns)
    const tableEl = this.table.$el || document
    const isExpand = type === collapseType.expand
    clearTimeout(checkExpandTimer)
    this.checkColumnFreeze(collapseAnimationGroup)
    if (isExpand) {
      resetColumnsWidth(collapseAnimationGroup)
      this.updateCollapseMap(collapseKeys, val, column)
      setColumnHighlight(column, visibleFlatColumns)
      const { isCollapseMoveCheck } = this.table.$props
      if (isUserClick && isCollapseMoveCheck !== false) {
        checkExpandTimer = setTimeout(() => {
          checkExpandColumnPosition(collapseAnimationGroup, {
            tableWidth: this.states.width,
            scrollPos,
            leftTableWidth: this.leftTableWidth,
            setTableScrollLeft: this.table.scrollToLeft
          })
        }, 500)
      }
    } else {
      removeColumnHighlight(column, visibleFlatColumns)
    }
    // 延迟的目的是为了在做展开的时候先把width：0.1绘制出来
    setTimeout(() => {
      const emitParams = {key, column, collapsed: val}
      renderHighlightGroup(collapseAnimationGroup, tableEl, type, this.updateCollapseMap.bind(this, collapseKeys, val, column), this, emitParams)
      column.collapsed = type !== collapseType.expand
      this.updateColumns()
    }, isExpand ? 20 : 0)
  },
  updateCollapseMap(collapseKeys, status, column) {
    const { key } = column
    const { visibleFlatColumns } = this.states
    for (let i = 0; i < collapseKeys.length; i++) {
      const collapseKey = collapseKeys[i]
      this.states.collapsedMap[collapseKey] = status
      const index = visibleFlatColumns.findIndex(col => col.key === collapseKey)
      if (index > -1) {
        const { childKeys = [], parentNodeKeys } = visibleFlatColumns[index] || {}
        // 子级的状态需要更新:
        childKeys && childKeys.length && childKeys.forEach(k => {
          this.$set(this.states.collapsedMap, k, status)
          const childCol = visibleFlatColumns.find(col => col.key === k)
          // 更新对应的column的 collapsed 状态, 如果也存在collapseKeys的话。
          if (childCol && childCol.collapseKeys && childCol.collapseKeys.length) {
            childCol.collapsed = status
          }
        })
        // 如果存在父级，则在展开的情况下父级也必须展开
        if (!status) {
          parentNodeKeys && parentNodeKeys.length && parentNodeKeys.forEach(k => {
            this.$set(this.states.collapsedMap, k, status)
          })
        }
      }
      this.updateVisibleFlatColumnsCol(key, {
        collapsed: status
      })
    }
    // 判断所有子节点是否被折叠，是则需要折叠自己
    if (column.childKeys && column.childKeys.length) {
      if (column.childKeys.every(k => this.states.collapsedMap[k])) {
        this.states.collapsedMap[key] = status
      }
    }
    this.updateColumns()
    if (this.usingRowColMerge) {
      this.updateTableData()
    }
  },
  updateVisibleFlatColumnsCol (key, obj) {
    const visibleFlatColumns = this.states.visibleFlatColumns
    const index = visibleFlatColumns.findIndex(col => col.key === key)
    if (index === -1) {
      return
    }
    const col = visibleFlatColumns[index]
    for (const colKey in obj) {
      if (!Object.hasOwnProperty.call(col, colKey)) {
        this.$set(col, colKey, obj[colKey])
      } else {
        col[colKey] = obj[colKey]
      }
    }
  },
  checkColumnFreeze(columnGroups) {
    try {
      const isAllHide = columnGroups.reduce((v, cur) => {
        v.push(...(cur.columnGroups || []).map(col => col.$show))
        return v
      }, []).every(status => status === false)
      if (isAllHide === true) {
        this.table.$message.warning('当前所有被控制列均被隐藏')
      }
    } catch (err) {
    }
  }
}

export default {
  data () {
    return {
      states: {
        collapsedMap: {}, // 折叠
      }
    }
  },
  methods: collapseMethods
}




// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/collapse.js